type GameModalProps = {
  visible: boolean;
  title?: string;
  onClickClose?: () => void;
};

const GameModal: React.FC<GameModalProps> = ({
  visible = false,
  title,
  children,
  onClickClose
}) => {
  if (!visible) return null;
  return (
    <div className='game-modal-container'>
      <div className='overlay' />
      <div className='modal-panel column'>
        <div className='header'>
          <p>{title}</p>
          <button className='button square' onClick={onClickClose}>
            X
          </button>
        </div>
        <div className='game-modal-content'>{children}</div>
      </div>
    </div>
  );
};

export default GameModal;
